module.exports = __webpack_public_path__ + "static/img/fi.2649533e.svg";